// extracted by mini-css-extract-plugin
export var actions = "SideBySideVideo-module--actions--6a3ee";
export var addLabel = "SideBySideVideo-module--addLabel--3aa07";
export var back = "SideBySideVideo-module--back--858cb";
export var btn = "SideBySideVideo-module--btn--0c2a5";
export var btnGhost = "SideBySideVideo-module--btnGhost--1c0b1";
export var btnWhitePill = "SideBySideVideo-module--btnWhitePill--a7cae";
export var card = "SideBySideVideo-module--card--de21b";
export var divider = "SideBySideVideo-module--divider--2e7f7";
export var enginePicker = "SideBySideVideo-module--enginePicker--34bb8";
export var enginePickerBtn = "SideBySideVideo-module--enginePickerBtn--ebd2d";
export var enginePickerLabel = "SideBySideVideo-module--enginePickerLabel--2cbc4";
export var error = "SideBySideVideo-module--error--86ca4";
export var footer = "SideBySideVideo-module--footer--d3d4e";
export var header = "SideBySideVideo-module--header--84ae4";
export var hint = "SideBySideVideo-module--hint--9ab8f";
export var isActive = "SideBySideVideo-module--isActive--3f22d";
export var isDone = "SideBySideVideo-module--isDone--c973a";
export var isSelected = "SideBySideVideo-module--isSelected--7961a";
export var landscape = "SideBySideVideo-module--landscape--f1211";
export var legal = "SideBySideVideo-module--legal--079ff";
export var or = "SideBySideVideo-module--or--a7617";
export var output = "SideBySideVideo-module--output--d657c";
export var outputMeta = "SideBySideVideo-module--outputMeta--229a5";
export var outputMetaStacked = "SideBySideVideo-module--outputMetaStacked--f77a9";
export var outputOverlay = "SideBySideVideo-module--outputOverlay--f8bd5";
export var outputOverlayBtn = "SideBySideVideo-module--outputOverlayBtn--e8925";
export var outputStacked = "SideBySideVideo-module--outputStacked--186e7";
export var playerControls = "SideBySideVideo-module--playerControls--aa722";
export var playerPlay = "SideBySideVideo-module--playerPlay--00746";
export var playerTime = "SideBySideVideo-module--playerTime--62f7c";
export var playerTimeline = "SideBySideVideo-module--playerTimeline--57dee";
export var playerTimelineFill = "SideBySideVideo-module--playerTimelineFill--9117d";
export var progress = "SideBySideVideo-module--progress--6ad42";
export var progressBar = "SideBySideVideo-module--progressBar--5273e";
export var root = "SideBySideVideo-module--root--9e4a9";
export var rootSplash = "SideBySideVideo-module--rootSplash--4f248";
export var sbs = "SideBySideVideo-module--sbs--47985";
export var sbsOverlay = "SideBySideVideo-module--sbsOverlay--140ef";
export var sbsStacked = "SideBySideVideo-module--sbsStacked--7e68d";
export var sbvSpin = "SideBySideVideo-module--sbv-spin--7c1d4";
export var selectedMeta = "SideBySideVideo-module--selectedMeta--dc51a";
export var selectedThumb = "SideBySideVideo-module--selectedThumb--6d8c9";
export var selectedThumbPlay = "SideBySideVideo-module--selectedThumbPlay--e36f5";
export var selectedVideo = "SideBySideVideo-module--selectedVideo--f0981";
export var selectedVideoHorizontal = "SideBySideVideo-module--selectedVideoHorizontal--7b179";
export var social = "SideBySideVideo-module--social--fcb72";
export var socialBtn = "SideBySideVideo-module--socialBtn--b69c3";
export var spinner = "SideBySideVideo-module--spinner--e9263";
export var splash = "SideBySideVideo-module--splash--0ad1e";
export var splashCopy = "SideBySideVideo-module--splashCopy--65711";
export var splashImage = "SideBySideVideo-module--splashImage--8b3d2";
export var splashMobileImage = "SideBySideVideo-module--splashMobileImage--ffb2a";
export var stepper = "SideBySideVideo-module--stepper--07e24";
export var stepperDot = "SideBySideVideo-module--stepperDot--c8433";
export var stepperDots = "SideBySideVideo-module--stepperDots--e82e8";
export var stepperLabel = "SideBySideVideo-module--stepperLabel--1d1f0";
export var subtitle = "SideBySideVideo-module--subtitle--b6cfc";
export var title = "SideBySideVideo-module--title--f9bde";
export var unsupported = "SideBySideVideo-module--unsupported--606a7";
export var unsupportedIcon = "SideBySideVideo-module--unsupportedIcon--eafba";
export var uploadLink = "SideBySideVideo-module--uploadLink--36743";
export var videoCard = "SideBySideVideo-module--videoCard--89990";
export var videoCardDesc = "SideBySideVideo-module--videoCardDesc--cf566";
export var videoCardThumb = "SideBySideVideo-module--videoCardThumb--32f23";
export var videoCardThumbOverlay = "SideBySideVideo-module--videoCardThumbOverlay--2fbc2";
export var videoCardThumbPlay = "SideBySideVideo-module--videoCardThumbPlay--381f3";
export var videoCardThumbPlayIcon = "SideBySideVideo-module--videoCardThumbPlayIcon--c40b6";
export var videoCardTitle = "SideBySideVideo-module--videoCardTitle--37810";
export var videoGrid = "SideBySideVideo-module--videoGrid--3a4cd";
export var videoGridLandscape = "SideBySideVideo-module--videoGridLandscape--f70d0";
export var videoGridMany = "SideBySideVideo-module--videoGridMany--27c12";
export var videoPreview = "SideBySideVideo-module--videoPreview--9ff2b";